<template>
  <div class="min-h-screen flex w-full">
    <RouterView />
  </div>
</template>
